<script setup lang="ts">
import { onMounted } from 'vue'
import { titleBar } from '@/composables/menu/title'
import { ElBadge } from 'element-plus'
import { getUnreadCountStore } from '@/composables/notification/notifications'

const { icon, name, category, isRaw, url } = defineProps({
  icon: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  category: {
    type: String,
    required: true
  },
  isRaw: {
    type: Boolean,
    required: false,
    default: false
  },
  url: {
    type: String,
    required: true
  }
})

onMounted(() => {
  console.log('titleBar.category: ', titleBar.value.category)
  console.log('category: ', category)
})

const emit = defineEmits(['onAction'])

function onAction() {
  emit('onAction', category)
}
</script>
<template>
  <div w-full flex="~ col">
    <div
      :class="titleBar.category === category && titleBar.lifeId === null ? 'bg-m-gradient' : ''"
      flex="~ row"
      text-main
      w-full
      items-center
      p-0
      text-base
      menu-item>
      <router-link :to="url" flex="~ row" @click="onAction" h-full grow items-center rounded px-4 py-1>
        <div flex="~ row" h-10 w-10 items-center pt-1.5>
          <el-badge
            :hidden="category !== 'notification' || getUnreadCountStore().count === 0"
            :value="getUnreadCountStore().count"
            class="item">
            <i :class="[icon]" inline-block h-6 w-6 text-left text-2xl></i>
          </el-badge>
        </div>
        <div max-w-36 grow truncate text-left font-bold>
          {{ isRaw ? name : $t(name) }}
        </div>
      </router-link>
      <div mr-2 h-8 w-8>
        <slot name="action"></slot>
      </div>
    </div>
    <div w-full py-0.7 pl-10>
      <slot name="children"></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.item {
  padding-top: 0px;
  margin-right: 0px;
}
</style>
